/** Brief red flash on the selection frame when a frozen geometry gesture is blocked. */
export const GEOMETRY_BLOCKED_PULSE_CLASS = 'editor-selection-geometry-blocked-pulse'

/** Keep in sync with `editor-selection-geometry-blocked-pulse` duration in `index.css`. */
export const GEOMETRY_BLOCKED_PULSE_MS = 450

/** Hover/drag cursor for frozen (geometry-blocked, not locked) objects. */
export const FROZEN_OBJECT_CURSOR = "url('/icons/frozen-object-cursor.svg') 5 5, not-allowed"

/**
 * True when a modifier add (e.g. shift+click) was rejected due to lock/freeze selection rules.
 * Caller should pulse the current selection chrome (same as blocked move/resize).
 */
export function isObjectSelectionAddRejected(args: {
  previousIds: readonly string[]
  incomingId: string
  incomingLocked: boolean
  incomingFrozen: boolean
  previousIncludesLocked: boolean
  previousIncludesFrozen: boolean
}): boolean {
  const {
    previousIds,
    incomingId,
    incomingLocked,
    incomingFrozen,
    previousIncludesLocked,
    previousIncludesFrozen,
  } = args

  if (previousIds.length === 0 || previousIds.includes(incomingId)) return false
  if (incomingLocked || incomingFrozen) return true
  if (previousIncludesLocked || previousIncludesFrozen) return true

  return false
}

/** True when additive text selection (marquee, etc.) was rejected for lock/freeze mix rules. */
export function isTextSelectionAddRejectedFromBatch(args: {
  previousLength: number
  hasFrozenSelected: boolean
  hasFrozenIncoming: boolean
  hasUnfrozenIncoming: boolean
  hasLockedSelected: boolean
  hasLockedIncoming: boolean
  hasUnlockedIncoming: boolean
}): boolean {
  const {
    previousLength,
    hasFrozenSelected,
    hasFrozenIncoming,
    hasUnfrozenIncoming,
    hasLockedSelected,
    hasLockedIncoming,
    hasUnlockedIncoming,
  } = args

  if (previousLength === 0) return false
  if (hasFrozenSelected && hasUnfrozenIncoming) return true
  if (!hasFrozenSelected && hasFrozenIncoming) return true
  if (hasLockedSelected && hasUnlockedIncoming) return true
  if (!hasLockedSelected && hasLockedIncoming) return true

  return false
}
